import type {ReactNode} from "react";
import type {OttopilotAdditionalButtonsConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventAdditionalButtonsConfig";
import {filterAdditionalButtonsVisibleForEvent} from "~/domainModels/eventTemplates";
import {EventAdditionalButtonTrigger} from "~/components/eventAdditionalButtonTrigger";
import type {EventContainerConstraint} from "~/domainModels/workspaceModules/eventContainersModule";
import {isListCardFooterRestrictedByGlobalConstraints} from "~/domainModels/workspaceModules/eventContainerEditPanelConstraints";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {EventWithEventContainer} from "~/utilities/apis/api";

export function renderEventTableAdditionalMenuItems(props: {
    row: EventWithEventContainer;
    additionalButtonConfig: Array<OttopilotAdditionalButtonsConfig>;
    currentUserTemplateIds: ReadonlySet<Uuid>;
    workspaceId: Uuid;
    onOpenAdditionalButtonModal: (payload: {config: OttopilotAdditionalButtonsConfig; event: EventWithEventContainer}) => void;
    /** Optional workspace config; disables Log/Cancel (etc.) when parent journey fails constraints. */
    globalConstraints?: Array<EventContainerConstraint>;
}): ReactNode {
    const visibleAdditionalConfigs = filterAdditionalButtonsVisibleForEvent({
        additionalButtons: props.additionalButtonConfig,
        event: props.row,
        currentUserTemplateIds: props.currentUserTemplateIds,
    });

    if (visibleAdditionalConfigs.length === 0) {
        return null;
    }

    const isRestrictedByGlobalConstraints = isListCardFooterRestrictedByGlobalConstraints(
        props.row.eventContainer,
        props.globalConstraints,
    );

    return visibleAdditionalConfigs.map((config) => (
        <EventAdditionalButtonTrigger
            key={config.id}
            config={config}
            event={props.row}
            layout="dropdownItem"
            currentUserTemplateIds={props.currentUserTemplateIds}
            workspaceId={props.workspaceId}
            onOpenModal={props.onOpenAdditionalButtonModal}
            shieldTableRowClick={true}
            isDisabled={isRestrictedByGlobalConstraints}
        />
    ));
}
